import styled, { css } from 'styled-components'
import { mq } from '../../styles/mq'

export const FullContainer = styled.div`
  position: relative;
  padding: 0 2rem;

  ${mq.medium} {
    padding: 0 4rem;
  }

  ${mq.large} {
    padding: 0 6rem;
  }

  ${mq.xlarge} {
    padding: 0 10rem;
  }

  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  scroll-snap-stop: normal;
  scroll-snap-align: center;
  overflow: hidden;

  &.introduction {
    display: flex;
    ${mq.medium} {
      display: none;
    }
  }

  &.long-for-mobile {
    min-height: 100vh;
    min-height: 100dvh;
    height: auto;
    display: block;

    ${mq.medium} {
      display: flex;
      height: 100%;
    }
  }
`

export const StickyContainer = styled.div`
  position: relative;
  width: 100%;
  height: 500%;

  scroll-snap-stop: normal;
  scroll-snap-align: center;
`
export const Answers = styled.div`
  position: -webkit-sticky;
  top: 0;
  position: sticky;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20%;
  ${mq.smallOnly} {
    width: 100%;
    margin: 0;
  }
  ${mq.medium} {
    width: calc(100% - 40px);
    margin: 0 20px;
  }
  ${mq.large} {
    width: calc(100% - 160px);
    margin: 0 80px;
  }
  ${mq.xlarge} {
    width: calc(100% - 200px);
    margin: 0 100px;
  }
`

export const Anchor = styled.div<{ $top: number }>`
  position: absolute;
  left: 0;
  width: 100px;
  height: 12.5%;
  top: ${(props) => props.$top}%;
`
export const Face = styled.div<{ $dir: string }>`
  --spacing: 0;

  padding: 0 var(--spacing);
  margin: 0 calc(-1 * var(--spacing));

  ${mq.medium} {
    --spacing: 6rem;
    display: flex;
    align-items: center;
    gap: 15%;
    overflow: hidden;
    max-height: 100dvh;

    ${(props) =>
      props.$dir !== 'left' &&
      css`
        flex-direction: row-reverse;
      `}
  }

  ${mq.xlarge} {
    --spacing: 10rem;
  }

  img {
    position: relative;
    width: 100%;
    flex-shrink: 0;
    margin-bottom: 2rem;
    transform: ${(props) =>
      props.$dir === 'left' ? 'scaleX(-100%);' : 'none'};
    mix-blend-mode: darken;

    ${mq.medium} {
      margin-bottom: 0;
      width: 46%;
      margin-inline: -15%;
    }
  }

  p {
    max-width: 905px;
    margin: 2.4rem auto;
  }
`

export const BottomSilhouettes = styled.div`
  position: absolute;
  bottom: -1.5vw;
  width: 100%;
  display: flex;
  img {
    position: relative;
    &:last-child {
      top: -0.95vw;

      @media (orientation: portrait) {
        display: none;
      }
    }
    width: 50%;
    @media (orientation: portrait) {
      width: 100%;
    }
  }
`
